<template>
  <div class="">
    <label
      class="form-label"
      :for="'fileUpload'+fileNumber"
    >
    .jpg ফরম্যাটের ছবি পছন্দ করুন{{fileNumber}} {{ isRequired ? '*' : '(Optional)' }}
    </label>
    <input
      :id="'fileUpload'+fileNumber"
      type="file"
      class="form-control"
      ref="file"
      accept=".jpg,.jpeg"
      :disabled="disabled || progress > 0"
      @change="handleFileSelect()"
    />
    <div v-if="progress > 0 && progress < 100" class="progress">
      <div
        :style="{'width': progress +'%'}"
        class="progress-bar progress-bar-striped progress-bar-animated"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
      />
    </div>
    <div
      v-if="file && progress === 100"
      class="btn btn-danger remove-button"
      @click="removeFile()"
    >
    বাতিল করুন
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    file: '',
    progress: 0,
  }),
  props: {
    fileNumber: {
      type: Number,
      default: 0,
    },
    uploadUrl: {
      type: String,
      default: '',
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleFileSelect() {
      [this.file] = this.$refs.file.files;
      this.uploadFile();
    },
    async uploadFile() {
      try {
        const config = {
          method: 'put',
          url: this.uploadUrl,
          headers: {
            'Content-Type': this.file.type,
          },
          onUploadProgress: (e) => {
            this.progress = parseInt(Math.round((e.loaded / e.total) * 100), 10);
          },
          data: this.file,
        };

        const res = await this.axios(config);

        this.$emit('fileUpload', { url: this.getFileNameFromResponse(res), fileNumber: this.fileNumber });
      } catch (err) {
        console.error(err);
      }
    },
    removeFile() {
      this.file = '';
      this.progress = 0;
      this.$refs.file.value = null;
      this.$emit('fileRemove', { fileNumber: this.fileNumber });
    },
    getFileNameFromResponse(response) {
      return response.config.url.replace('https://somoy-video-campaign-pot.s3.ap-southeast-1.amazonaws.com/', '').split('?')[0];
    },
  },
};
</script>
<style lang="stylus" scoped>
.remove-button
  position absolute
  top -5px
  right 0
</style>
